import type { ReactNode } from "react";

import { usePreservedOverflowScroll } from "../../../hooks/usePreservedOverflowScroll";

const SCROLL_BODY_CLASS_NAME =
	"scrollbar-hide min-h-0 flex-1 overflow-y-auto px-4 pb-3 [overflow-anchor:none]";

/** Scrollable field list between a pinned header and footer. */
export const EditScrollBody = ({ children }: { children: ReactNode }) => {
	const scroll = usePreservedOverflowScroll<HTMLDivElement>();

	return (
		<div className={SCROLL_BODY_CLASS_NAME} {...scroll}>
			{children}
		</div>
	);
};
